export const ADRUM_EVENT = {
  identification: 'identification',
  address: 'Petis.Address',
  contact: 'Petis.Contact',
}
